import Contact from './contact';
import {FormAjax} from './../../../../front/static/src/tools/form.ajax.es6';

$(document).ready(function() {
    const $form = Contact.getForm();
    if ($form.length) {
        new FormAjax($form, (response, e) => {
            Contact.success(response);
        }, (response, e) => {
            Contact.error();
        });
    }
});